export { FlowerIcon } from './flower-icon';
export type { FlowerIconProps } from './flower-icon';
